import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ProcessLogOrderSummaryViewModule = new Module({
  id: 'PROCESS-LOG-ORDER-SUMMARY:RESULT-TABLE',
  name: 'Process Log Order Summary',
  label: 'Process Log Order Summary',
  path: 'process-log-order-summary',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/ProcessLogOrderSummary/View'))
  ),
  actions: {
    viewDetails: {
      id: 'PROCESS-LOG-ORDER-SUMMARY:VIEW:DETAILS',
      name: 'viewDetails',
      label: 'View Detailed Logs'
    }
  }
});

const ProcessLogOrderSummaryModules = [ProcessLogOrderSummaryViewModule];

export default new ModuleBundle(
  'ProcessLogOrderSummary',
  ProcessLogOrderSummaryModules
);
